import { QueryKey, useQuery } from "@tanstack/react-query";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { downloadFile } from "./utils";

import "./styles.scss";

export interface ITextFileDownloadProps {
  queryKey: QueryKey;
  queryFunction: () => Promise<{ filename: string; content: string }>;
}

export const TextFileDownload = ({
  queryKey,
  queryFunction,
}: ITextFileDownloadProps) => {
  const t = (key: string) => _t(`textFileDownload.${key}`);
  const { t: _t } = useTranslation();

  const query = useQuery({
    queryKey: queryKey,
    queryFn: queryFunction,
    enabled: false,
  });

  const beginDownload = () => {
    query.refetch();
  };

  const downloadButtonTextKey = useMemo(() => {
    if (query.isFetching) {
      return "loading";
    }
    if (!!query.data || !!query.error) {
      return "download_again";
    }
    return "download";
  }, [query]);

  return (
    <div className="text-file-download">
      <div className="buttons">
        <button
          className="btn btn-border"
          disabled={query.isFetching}
          onClick={beginDownload}
        >
          {t(downloadButtonTextKey)}
        </button>

        {query.data && (
          <>
            <button
              className="btn btn-border"
              onClick={() =>
                downloadFile({
                  filename: query.data.filename,
                  content: query.data.content,
                  encoding: "utf-8",
                })
              }
            >
              {t("save_utf8")}
            </button>
            <button
              className="btn btn-border"
              onClick={() =>
                downloadFile({
                  filename: query.data.filename,
                  content: query.data.content,
                  encoding: "Shift_JIS",
                })
              }
            >
              {t("save_shift_jis")}
            </button>
          </>
        )}
      </div>
      {query.isError && <div className="error">{t("error")}</div>}
    </div>
  );
};
